import React from 'react';
import LoadMore from "../common/LoadMore";
import './index.css';
import util from "../../util/tools";
import Header from "../common/Header";

export default class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            page: 1,
            curTitle: "我的余额",
            curTab: 0,//默认充值记录
            isLoad:false,
            data:[],
        };
    }

    componentDidMount() {
        document.title = this.state.curTitle;
        this.getData()
    }

    tapTabs(e,index) {
        this.setState({
            page: 1,
            data: [],
            curTab: index,
            isLoad:false
        },()=>{
            this.getData()
        })
    }

    getData(){
        let params = {
            url: "/zh/pay/lists",
            data: {
                'page':this.state.page,
                'num':20,
                '__flush_cache': 1
            }
        };
        if(this.state.curTab == 1){
            params.url = "/zh/consume/listsv1";
        }
        util.ajax({
            url: params.url,
            isUser: true,
            isWechatId: true,
            data: params.data,
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    let tempData = {
                        data : this.state.data.concat(json)
                    };

                    if(json.length == params.data.num){
                        // 未到最后一页
                        tempData.isLoad = true;
                        tempData.page = parseInt(this.state.page) + 1;
                    }else{
                        tempData.isLoad = false;
                    }
                    this.setState(tempData);
                }
            }
        });
    }

    render() {
        return (
            <div className='balance'>
                <Header />
                <div className='balance_tabs' >
                    <div className={`balance_tabs_single ${this.state.curTab == 0 ? 'balance_tabs_singleActive' : ''}`} onClick={(e) => this.tapTabs(e,0)}>
                        <span>充值记录</span>
                        <i className='balance_tabs_single_line'></i>
                    </div>
                    <div className={`balance_tabs_single ${this.state.curTab == 1 ? 'balance_tabs_singleActive' : ''}`} onClick={(e) => this.tapTabs(e,1)}>
                        <span>消费记录</span>
                        <i className='balance_tabs_single_line'></i>
                    </div>
                </div>

                {this.state.curTab == 0 ?
                    //充值记录
                    <div className='balance_lists'>
                        {
                            !!this.state.data && this.state.data.length>0&&!!this.state.data[0].order_no ?
                                this.state.data.map((item,index) =>{
                                    return (
                                        <div className='balance_lists_single' key={`list_${index}`}>
                                            <div className='balance_lists_single_top'>
                                                <span className='balance_lists_single_top_coin'>+{item.pay_coin}金币</span>
                                                {
                                                    parseInt(item.give_coin)>0?<span className='balance_lists_single_top_packet'>+{item.give_coin}红包</span>:''
                                                }

                                            </div>
                                            <div className='balance_lists_single_bot'>
                                                <span className='balance_lists_l'>订单号：{item.order_no}</span>
                                                <span className='balance_lists_r'>{!!item.create_time?(item.create_time).split(' ')[0]:""}</span>
                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <div style={{textAlign:'center',paddingTop:'1rem'}}>
                                    <img  src={require('../../../common/images/norecord.png')} style={{width:'54%'}}/>
                                    <p style={{fontSize:'16px',marginTop:'0.4rem'}}>当前并无充值记录</p>
                                </div>
                        }
                        {this.state.isLoad && <LoadMore loadMoreData={()=>this.getData()}/>}
                    </div>
                    :
                    //消费记录
                    <div className='balance_listsNext'>
                        {
                            !!this.state.data && this.state.data.length>0&&!!this.state.data[0].book_id ?
                                this.state.data.map((item, index) => {
                                    return (
                                        <div className='balance_listsNext_single' key={`order_${index}`}>
                                            <div className='balance_listsNext_single_top'>
                                                <span className='balance_listsNext_single_top_l'>{item.book_title}</span>
                                                <span className='balance_listsNext_single_bot_r'>-{item.coin}金币</span>
                                            </div>
                                            <div className='balance_listsNext_single_bot'>
                                                <span className='balance_listsNext_single_bot_l'>{item.consume_type==1?'单章购买：':item.consume_type==2?'整本购买':item.consume_type==3?'打赏作品：':''}{item.chapter_title}</span>
                                                <span className='balance_listsNext_single_bot_r'>{!!item.consume_time?item.consume_time.split(' ')[0]:""}</span>
                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <div style={{textAlign:'center',paddingTop:'1rem'}}>
                                    <img  src={require('../../../common/images/norecord.png')} style={{width:'54%'}}/>
                                    <p style={{fontSize:'16px',marginTop:'0.4rem'}}>当前并无消费记录</p>
                                </div>
                        }
                        {this.state.isLoad && <LoadMore loadMoreData={()=>this.getData()}/>}
                    </div>
                }
            </div>
        );
    }
}